import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import AppNavBar from "../../components/navbar";
import AppFooter from "../../components/footer";
import { useLayout } from "../../context/LayoutContext";
import "./AppLayout.css";

const AppLayout = () => {
  const { navbarConfig } = useLayout();

  return (
    <div className="app-layout-shell">
      {navbarConfig.showNavbar !== false && (
        <Suspense fallback={<div className="layout-loader">Loading Navigation...</div>}>
          <AppNavBar {...navbarConfig} />
        </Suspense>
      )}

      <main className="app-layout-main">
        <Outlet />
      </main>

      <Suspense fallback={null}>
        {navbarConfig.showFooter !== false && <AppFooter />}
      </Suspense>
    </div>
  );
};

export default AppLayout;
